import React, { useEffect, useState } from "react";
import Room from "./Room";
import Home from "./Home";

function App() {
  const [room, setRoom] = useState(null);

  useEffect(() => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith("meetData="))
      ?.split("=")[1];
    if (cookies) {
      const data = JSON.parse(decodeURIComponent(cookies));
      console.log("data", data);
      setRoom(data);
    }
  }, []);

  // data.token
  // data.name
  // data.roomName
  // data.appId
  // data.logo

  return room ? <Room data={room} /> : <Home />;
}

export default App;
